import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Tailwind-aware class joiner. Used by all shadcn primitives.
 * `cn('px-2 py-1', condition && 'bg-brix-primary')`
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
